import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useProaqStatus = () => {
  const [proaqStatus, setProaqStatus] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchProaqStatus = async () => {
      try {
        const response = await httpClient.get(`/api/proaq/statusproaq`);

        const options = response.data.map(
          (proaqStatus: { value: number; label: string }) => ({
            value: proaqStatus.value.toString(),
            label: proaqStatus.label,
          }),
        );
        setProaqStatus(options);
      } catch (error) {
        console.error('Erro ao buscar Status do Processo Aquisitivo', error);
      }
    };

    fetchProaqStatus();
  }, []);

  return proaqStatus;
};
